export const PridobivanjeTock = {
  methods: {
    PreveriStanjeTock (prenosniParam) {
      if (prenosniParam.prenesenIzbranId !== '') {
        let param = ['idStranka=' + prenosniParam.prenesenIzbranId]
        this.clientAgent.postWsRequest(this,
          '/klub/steviloTock?',
          param,
          prenosniParam,
          'SetPreveriTocke',
          'ErrPreveriTocke')
      }
    },
    SetPreveriTocke (podatki, prenosniParam) {
      let steviloTock = podatki.stanjeTock
      let vmesnik = prenosniParam.vmesnik
      vmesnik.PridobiPodatkeTockeKlub(prenosniParam, steviloTock)
    },
    ErrPreveriTocke (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/Klub/PridobivanjeTock.js